import { chipClasses } from "@mui/material";
const CHIP_SMALL_HEIGHT = '20px';
const MuiChip = {
    defaultProps: {
        variant: 'filled',
        size: 'small'
    },
    styleOverrides: {
        root: {
            borderRadius: '4px'
        },
        sizeSmall: {
            height: CHIP_SMALL_HEIGHT
        },
        deleteIcon: ({ theme })=>({
                padding: '2px',
                color: theme.palette.text.secondary
            }),
        icon: ({ theme })=>({
                color: theme.palette.text.primary,
                width: '12px',
                height: '12px'
            }),
        iconSmall: ({ theme })=>({
                marginLeft: theme.spacing(1)
            }),
        labelSmall: {
            fontSize: '12px'
        },
        filled: ({ theme })=>{
            const darkModeBackgroundColor = 'dark' === theme.palette.mode ? theme.palette.grey[300] : theme.palette.status.default.lowContrast;
            return {
                backgroundColor: darkModeBackgroundColor,
                border: `1px solid ${darkModeBackgroundColor}`,
                color: theme.palette.text.primary,
                [`& .${chipClasses.icon}`]: {
                    color: theme.palette.text.primary
                }
            };
        },
        outlined: ({ theme })=>({
                backgroundColor: theme.palette.background.container,
                border: `1px solid ${theme.palette.border.subtle}`,
                color: theme.palette.text.secondary,
                '&:hover, &:focus': {
                    backgroundColor: theme.palette.background.hover
                },
                [`& .${chipClasses.icon}`]: {
                    color: theme.palette.text.secondary
                }
            })
    }
};
export { CHIP_SMALL_HEIGHT, MuiChip };

//# sourceMappingURL=chip-overrides.js.map